import { crudActionCreatorsGenerator } from './crud_action_creators_generator';
import { crudActionConstantsGenerator } from './crud_action_constants_generator';

export const CONTRACTOR_PROBLEM_TYPES_CRUD_ACTION_CONSTANTS = crudActionConstantsGenerator(
	'CONTRACTOR_PROBLEM_TYPES'
);
export const CONTRACTOR_PROBLEM_TYPES_CRUD_ACTION_CREATORS = crudActionCreatorsGenerator(
	CONTRACTOR_PROBLEM_TYPES_CRUD_ACTION_CONSTANTS
);
